import $ from '@nodeModules/jquery';
import '@nodeModules/slick-carousel-latest';

export const initFeaturedLocations = () => {
	const $locationsPrevArrowEl = document.querySelector('.featured-locations__slider-nav-action--prev');
	const $locationsNextArrowEl = document.querySelector('.featured-locations__slider-nav-action--next');

	const $featuredLocationsSlider = document.querySelector('.featured-locations__slider');
	if ($featuredLocationsSlider) {
		$('.featured-locations__slider').on('init', function(event, slick) {
			$featuredLocationsSlider.classList.add('featured-locations__slider--is-initialized');
		}).slick({
	        dots: false,
	        autoplay: true,
	        centerMode: false,
	        speed: 1000,
	        rows: 0,
	        prevArrow: $locationsPrevArrowEl,
	        nextArrow: $locationsNextArrowEl,
	        responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1
					}
				},
			]
	    });
	}
};